<template>

    <div class="container">

        <app-head title="Orders" />

        <account-link />

        <div class="my-4">
            <h1>{{ __('Orders') }}</h1>
        </div>

        <div class="d-flex align-items-center mb-3">
            <search-filter v-model="form.search" class="" @reset="reset" :placeholder="__('Suche in Bestellungen')">
            </search-filter>
            <!--            <div class="ms-3">
                            <inertia-link :href="route('orders.index', {status: 'archived'})" v-if="filters.status !== 'archived'">
                                {{ __('Archivierte Bestellungen anzeigen (:count)', {count: totalArchivedOrders}) }}
                            </inertia-link>
                        </div>-->
        </div>

        <div v-if="groupedOrders.meta.total === 0">
            {{ __('Keine Bestellungen') }}
        </div>

        <template v-else>

            <div class="d-grid gap-4">
                <grouped-order v-for="groupedOrder in groupedOrders.data" :grouped-order="groupedOrder" :key="groupedOrder.internal_order_number" />
            </div>

            <pagination :links="groupedOrders.meta.links" />

        </template>

    </div>

</template>

<script>
    import GroupedOrder from './GroupedOrder';
    
    import Pagination from '@/shared/Pagination';
    import AccountLink from '@/shared/AccountLink';
    import SearchFilter from '@/shared/SearchFilter';

    export default {
        props: [
            'groupedOrders',
            'filters',
            'totalArchivedOrders',
        ],
        data() {
            return {
                form: {
                    search: this.filters.search,
                },
            }
        },
        components: {
            GroupedOrder,
            Pagination,
            AccountLink,
            SearchFilter,
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('orders.index'), this.form, {preserveState: true, preserveScroll: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>